import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Avatar, Tooltip } from "antd";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import TopNavigation from "./TopNavigation";

import { logoutUser } from "../redux/auth";

const HeaderLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleProfileClick = () => {
    navigate("/profile");
  };

  const handleLogout = () => {
    logoutUser(dispatch);
    navigate("/signin"); // Redirect to the sign-in page after logout
  };

  let user = window.localStorage.getItem("user_params");
  if (user) {
    user = JSON.parse(user);
  }

  return (
    <header className="header">
      <div className="logo">
        <Button icon={<MenuOutlined />} className="menuButton">
          Меню
        </Button>

        <h3 className="menuText">
          Информационно-аналитическая система «Мониторинг и прогноз
          социально-экономических показателей»{" "}
        </h3>
      </div>
      <TopNavigation {...{ user }} />
      <div className="exit">
        {user && (
          <Tooltip title="Профиль пользователя">
            <Button
              type="link"
              onClick={handleProfileClick}
              style={{
                marginRight: 12,
                display: "flex",
                alignItems: "center",
                color: "white",
              }}
            >
              <Avatar
                size="small"
                icon={<UserOutlined />}
                style={{ marginRight: 8 }}
              />
              {user.username}
            </Button>
          </Tooltip>
        )}
        <Button onClick={handleLogout} style={{ marginRight: 6 }}>
          Выйти
        </Button>
      </div>
    </header>
  );
};

export default HeaderLayout;
